var form_module_default = {
	root: "_root_1o4d9_17",
	field: "_field_1o4d9_27",
	"inline-field": "_inline-field_1o4d9_33",
	"inline-field-body": "_inline-field-body_1o4d9_39",
	"inline-field-control": "_inline-field-control_1o4d9_45",
	label: "_label_1o4d9_60",
	message: "_message_1o4d9_86",
	"help-message": "_help-message_1o4d9_92",
	"error-message": "_error-message_1o4d9_96",
	"success-message": "_success-message_1o4d9_100"
};
//#endregion
export { form_module_default as default };

//# sourceMappingURL=form.module.js.map